import React from "react";
import PropTypes from "prop-types";
import { FormGroup } from "@blueprintjs/core";

function Field(_ref) {
  var className = _ref.className,
      label = _ref.label,
      inline = _ref.inline,
      required = _ref.required,
      children = _ref.children;

  return React.createElement(
    FormGroup,
    {
      className: "dt-field " + (className || ""),
      inline: inline,
      label: label || false,
      labelInfo: required && React.createElement(
        "span",
        { className: "required" },
        "(*)"
      )
    },
    children
  );
}

Field.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  label: PropTypes.string,
  inline: PropTypes.bool,
  required: PropTypes.bool,
  children: PropTypes.node
} : {};

export default Field;